/*
 * @Date: 2024-11-01 11:45:42
 * @LastEditors: Mipawn dongzhan@mipawn.com
 * @LastEditTime: 2024-11-04 17:30:12
 * @Author: Mipawn
 * @Description: fb 绑定弹窗
 */

import { useRequest } from 'ahooks';
import { useEffect } from 'react';

import * as fbApi from '@/api/fb';
import { implog } from '@/api/implog';
import imgCoinLeft from '@/assets/modal/coins_left.webp';
import imgCoinRight from '@/assets/modal/coins_right.webp';
import imgFb from '@/assets/modal/fb.webp';
import Button from '@/components/button/index';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import { goFbLogin } from '@/utils/apk';
import emitter from '@/utils/event-bus';

import styles from './index.module.less';

export const FbBindModal = (modal, close, { data }) => {
  const { run: updateInfo, data: newData } = useRequest(fbApi.getFbBindInfo, { manual: true, debounceWait: 300 });

  const goFbBind = () => {
    implog('fb_bind_modal_click');
    goFbLogin(JSON.stringify(data));
  };

  useEffect(() => {
    implog('fb_bind_modal_show');

    emitter.on('fb_bind_info_update', () => {
      updateInfo();
    });
  }, []);

  useEffect(() => {
    if (newData && newData?.has_bind === 1) {
      close();
    }
  }, [newData]);

  return (
    <div className={styles.container}>
      <div className={styles.cover}>
        <BlurryLoadingImage src={imgFb} />
      </div>
      <div className={styles.body}>
        <div className={styles.title}>
          Congratulations! <br /> You are a lucky player!{' '}
        </div>
        <div className={styles.sub_title}>
          {' '}
          Link your Facebook <br />
          to receive
        </div>

        <div className={styles.price}>$5</div>
        <div className={styles.button}>
          <Button block type="success" onClick={goFbBind}>
            LINK
          </Button>
        </div>
      </div>

      <div className={styles.bg}>
        <BlurryLoadingImage src={imgCoinLeft} className={styles.coin_left} />
        <BlurryLoadingImage src={imgCoinRight} className={styles.coin_right} />
      </div>
    </div>
  );
};

const showFbBindModal = options => {
  return showNiceModal(
    {
      render: FbBindModal,
      width: '6rem',
      maskClosable: true,
      contentStyle: {
        overflow: 'initial'
      },
      ...options
    },
    'fb-bind-modal'
  );
};

export default showFbBindModal;
